/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import axios from "axios";
import { getToken } from "../../../auth";

//BASE_URL
const API_URL = process.env.REACT_APP_API_URL;
const Category_URL = `${API_URL}`;

const listCategoryData = async (ChefId: any, filterData: any) => {
  const response = await axios.post(`${API_URL}list-Categorys/${ChefId}`, filterData, getToken());

  return response.data;
};

const updateCategory = async (id: any, updatedData: any) => {
  const res = await axios.put(`${Category_URL}update-category/${id}`, updatedData, getToken());
  return res.data;
};

const deleteCategory = async (id: any) => {
  const response = await axios.put(`${Category_URL}/delete-Categorys/${id}`, getToken());
  return response.data;
};
const enableStatus = async (id: any, enableDisableStatus: any) => {

  const response = await axios
    .put(`${API_URL}enable-disable-Categorys/${id}`, enableDisableStatus, getToken());
  return response.data;
};

const CreateCategorys = async (data: any) => {
  const res = await axios.post(`${Category_URL}/add-Categorys`, data, getToken());
  return res.data;
};

const viewCategoryById = async (id: any) => {
  const response = await axios.get(`${Category_URL}view-Categorys/${id}`, getToken());
  return response.data;
};

const checkDuplicateCategory = async (chefId: any, name: any,) => {
  const response = await axios
    .post(`${Category_URL}find-duplicate-category`, { chefId, name }, getToken());
  return response.data;
};
const getType = async () => {
  const res = await axios.get(`${API_URL}get-type`, getToken());
  return res;
};
export {
  listCategoryData, getType,
  CreateCategorys,
  updateCategory,
  deleteCategory,
  viewCategoryById,
  enableStatus,
  checkDuplicateCategory,
};
